var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateRoles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19998_27210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6511 11.8459C16.2188 13.4743 15.2771 14.9211 13.9651 15.9725C12.6532 17.0238 11.0407 17.6238 9.36625 17.6836C7.69178 17.7435 6.04422 17.2601 4.66724 16.3049C3.29027 15.3497 2.25702 13.9735 1.72032 12.3797C1.18361 10.786 1.17195 9.05936 1.68706 7.45527C2.20218 5.85118 3.2167 4.45479 4.58059 3.47264C5.94448 2.49049 7.5853 1.97473 9.26036 2.00166C10.9354 2.02859 12.5558 2.59677 13.8817 3.62217M13.8817 3.62217L13.4726 1.53234M13.8817 3.62217L11.9218 4.44231",
    stroke: "#021472",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.10309,
    cy: 9.45271,
    rx: 2.4527,
    ry: 2.45271,
    stroke: "#021472",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0177 13.8933H7.63277C6.07487 13.8933 5.0002 16 6 17",
    stroke: "#021472",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86786 13.8933H11.2528C12.8106 13.8933 13.5128 15.2803 12.5 17",
    stroke: "#021472",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19998_27210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateRoles);
export default __webpack_public_path__ + "static/media/updateRoles.f85514384bff5da616a822107db60c19.svg";
export { ForwardRef as ReactComponent };